var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ais-configure',_vm._b({attrs:{"hitsPerPage":_vm.hitsPerPage,"facets":_vm.uniqueFacets,"filters":_vm.innerFilters,"attributesToRetrieve":_vm.attributesToRetrieve}},'ais-configure',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }